<template>
  <div class="container-page">
    <p class="title-inner">Индекс лучшей жизни ОЭСР</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <DefaultFilter class="mb-16" :filterValue="filter" @loadFilter="onLoadFilter" />
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Страна</th>
              <th>Жилье</th>
              <th>Доход</th>
              <th>Работа</th>
              <th>Социальная поддержка</th>
              <th>Образование</th>
              <th>Окружающая среда</th>
              <th>Вовлечение гражданского общества</th>
              <th>Здоровье</th>
              <th>Удовлетворенность жизнью</th>
              <th>Безопасность</th>
              <th>Баланс между работой и личной жизнью</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  v-model="filter.year"
                  type="year"
                  placeholder="Год"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.countryId"
                  placeholder="(Все)"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter" colspan="11"></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ item.country?.nameFull || item.country?.name }}</td>
              <td>{{ item.housingExpenditure?.toFixed(2) }}</td>
              <td>{{ item.householdIncome?.toFixed(2) }}</td>
              <td>{{ item.employmentRate?.toFixed(2) }}</td>
              <td>{{ item.qualityNetwork?.toFixed(2) }}</td>
              <td>{{ item.educationalAttainment?.toFixed(2) }}</td>
              <td>{{ item.airPollution?.toFixed(2) }}</td>
              <td>{{ item.stakeholderEngagement?.toFixed(2) }}</td>
              <td>{{ item.lifeExpectancy?.toFixed(2) }}</td>
              <td>{{ item.lifeSatisfaction?.toFixed(2) }}</td>
              <td>{{ item.homicideRate?.toFixed(2) }}</td>
              <td>{{ item.workingBalance?.toFixed(2) }}</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="13">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="13">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import FilterInput from '../../../common/components/FilterInput.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.LifeIndexView,
    import: Constants.Permissions.LifeIndexImport,
  };

  export default {
    name: 'LifeIndex',
    components: { FilterInput, ImportModal, ModalComponent, ButtonComponent, DefaultFilter },
    mixins: [security],
    data() {
      return {
        route: 'lifeindex',
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          year: null,
          countryId: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,

        select2Settings: Constants.select2Settings,
        countries: [],
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        request.isImport = null;
        if (this.filter.type == 0) request.isImport = false;
        else if (this.filter.type == 1) request.isImport = true;

        Api.search(this.route, request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylistwithdata', {})
          .then((response) => {
            this.countries = response.data.map((x) => {
              return { text: x.name, id: x.id };
            });
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            Constants.alert.fire(
              'Импорт',
              error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
              'error',
            );
            this.importInProgress = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      closeModal() {
        this.importModal = false;
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>
